module.exports = __webpack_public_path__ + "static/img/yiNew1.dfd8ebe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/yiNew1.jpg
// module id = tW24
// module chunks = 0